import React from 'react';

import ExternalLink, {
	ExternalLinkStyle,
} from '~/components/patterns/links/ExternalLink';

import {
	FormattedMessage,
	defineMessages,
} from 'react-intl';



const messages = defineMessages({
	copyright: {
		id: 'ui.conductorAuthFooter.copyright',
		defaultMessage: 'Copyright {year}. Conductor LLC. All rights reserved.',
	},
	termsOfService: {
		id: 'ui.conductorAuthFooter.termsOfService',
		defaultMessage: 'Terms of Service',
	},
	privacy: {
		id: 'ui.conductorAuthFooter.privacy',
		defaultMessage: 'Privacy',
	},
	questions: {
		id: 'ui.conductorAuthFooter.questions',
		defaultMessage: 'Questions?',
	},
	learningCenter: {
		id: 'ui.conductorAuthFooter.learningCenter',
		defaultMessage: 'Conductor Learning Center',
	},
	blog: {
		id: 'ui.conductorAuthFooter.blog',
		defaultMessage: 'Conductor Blog',
	},
});



const ConductorAuthFooter: React.FC = () => {
	const currentYear = new Date().getFullYear();

	return (
		<div className="conductor-auth-footer">
			<div className="conductor-auth-footer__content">
				<span className="conductor-auth-footer__copyright">
					<FormattedMessage
						{...messages.copyright}
						values={{ year: currentYear }}
					/>
				</span>
				<ExternalLink
					href="https://www.conductor.com/legal/service-agreement/"
					style={ExternalLinkStyle.Auth}
					target="_blank"
				>
					<FormattedMessage {...messages.termsOfService} />
				</ExternalLink>
				<span className="conductor-auth-footer__separator">|</span>
				<ExternalLink
					href="https://www.conductor.com/legal/privacy-policy/"
					style={ExternalLinkStyle.Auth}
					target="_blank"
				>
					<FormattedMessage {...messages.privacy} />
				</ExternalLink>
				<span className="conductor-auth-footer__separator">|</span>
				<ExternalLink
					href="mailto:support@conductor.com"
					style={ExternalLinkStyle.Auth}
					target="_blank"
				>
					<FormattedMessage {...messages.questions} />
				</ExternalLink>
				<span className="conductor-auth-footer__separator">|</span>
				<ExternalLink
					href="https://www.conductor.com/academy/"
					style={ExternalLinkStyle.Auth}
					target="_blank"
				>
					<FormattedMessage {...messages.learningCenter} />
				</ExternalLink>
				<span className="conductor-auth-footer__separator">|</span>
				<ExternalLink
					href="https://www.conductor.com/blog/"
					style={ExternalLinkStyle.Auth}
					target="_blank"
				>
					<FormattedMessage {...messages.blog} />
				</ExternalLink>
			</div>
		</div>
	);
};



export default ConductorAuthFooter;
